import React from "react";
import {
  clearAccountingTransaction,
  clearAcctTransactionError,
  requestCreateAcctTransaction,
  requestDeleteAcctTransaction,
  requestDeleteCashTransaction,
  requestListAccount,
  requestListPartnerCashTransaction,
  requestListPartnerTransaction,
  useAccountingDispatch,
  useAccountingState,
  useBusinessTransactionDispatch,
  useBusinessTransactionState,
  clearBusinessTransaction,
  clearBusinessTransactionError,
  usePeriodLock,
} from "../../Context";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import {
  cancelAPIRequest,
  classNames,
  convertToTitleCase,
  getErrorMessages,
  getPeriodClosedError,
  parseTypedClosedDate,
} from "../../Utils";
import PeriodLockBanner from "../../Components/v2/Accounting/PeriodLockBanner";
import PeriodLockCell from "../../Components/v2/Accounting/PeriodLockCell";
import PeriodClosedNotice from "../../Components/v2/Accounting/PeriodClosedNotice";
import { NumericFormat } from "react-number-format";
import { PencilAltIcon, TrashIcon, EyeIcon } from "@heroicons/react/outline";
import ErrorStateTable from "../../Components/ErrorStateTable";
import TableSkeleton from "../../Components/TableSkeleton";
import { Pagination } from "../../Components/Pagination";
import { useState } from "react";
import { ModalAlert } from "../../Components/ModalAlert";
import { Alert } from "../../Components/Alert";
import Badge from "../../Components/Badge";
import { Modal } from "../../Components/Modal";
import { Button } from "../../Components/Button";
import { ModalConfirm } from "../../Components/ModalConfirm";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import { useRef } from "react";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
  Transition,
} from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";
import {
  dateFilterOptions,
  partnerTransactionTypesOptions,
} from "../../Constants";

const receivableTransactionTypes = ["RECEIVABLE", "INCOME_RECEIVABLE"];

const PartnerTransactionList = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const accountingDispatch = useAccountingDispatch();
  const businessTransactionDispatch = useBusinessTransactionDispatch();

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPaymentModal, setshowPaymentModal] = useState(false);
  const [showSuccessModal, setshowSuccessModal] = useState(false);
  const [showErrorModal, setshowErrorModal] = useState(false);

  const [inputErrors, setinputErrors] = useState({});
  const [selectedAccount, setselectedAccount] = useState(null);
  const [paymentDate, setpaymentDate] = useState(new Date());
  const [totalPaid, settotalPaid] = useState("");
  const [paymentDescription, setpaymentDescription] = useState("");

  const [page, setpage] = useState(1);
  const [partnerTransactionID, setpartnerTransactionID] = useState("");
  const [partnerCashTransactionID, setpartnerCashTransactionID] = useState("");
  const [getPartnerTransaction, setgetPartnerTransaction] = useState({});
  const [debitAccount, setDebitAccount] = useState(null);
  const [creditAccount, setCreditAccount] = useState(null);
  const [date, setdate] = useState(new Date());
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;
  const [createdAt, setcreatedAt] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(dateFilterOptions[0]);
  const [selectedTransaction, setselectedTransaction] = useState(
    partnerTransactionTypesOptions[0],
  );

  const {
    request: accountingRequest,
    accounts,
    submitLoading,
    submitError,
    deletedID,
    partnerTransactionsLoading,
    partnerTransactionsError,
    partnerTransactions,
    partnerTransactionsNextTokens,
    transactionID,
  } = useAccountingState();

  // Every accounting row on a partner page belongs to the same business, so the
  // first row names it; the open payment modal is the fallback before the list
  // has resolved.
  const periodBusinessID =
    partnerTransactions?.[0]?.business?.id ||
    getPartnerTransaction?.business?.id;
  const {
    minDate: periodMinDate,
    isDateClosed,
    isClosed: periodClosed,
    closedThroughLabel,
    refetch: refetchPeriod,
  } = usePeriodLock(periodBusinessID, { locale: i18n.language });
  const paymentDateLocked = isDateClosed(paymentDate);

  const {
    request: cashbookRequest,
    deletedId: cashTransactionDeleteID,
    deleteLoading,
    submitError: submitErrorCashbook,
    partnerCashTransactionsLoading,
    partnerCashTransactionsError,
    partnerCashTransactions,
    partnerCashTransactionsNextTokens,
  } = useBusinessTransactionState();

  const isFormSubmit = useRef(false);

  useEffect(() => {
    if (id && selectedTransaction && createdAt) {
      onLoad();
      clearAcctTransactionError(accountingDispatch);
      clearBusinessTransactionError(businessTransactionDispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, selectedTransaction]);

  useEffect(() => {
    return () => {
      clearAccountingTransaction(accountingDispatch);
      clearAcctTransactionError(accountingDispatch);
      clearBusinessTransaction(businessTransactionDispatch);
      clearBusinessTransactionError(businessTransactionDispatch);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (createdAt) {
      const isDateRangeValid = dateRange[0] !== null && dateRange[1] !== null;

      if (selectedFilter?.value !== "OTHER" || isDateRangeValid) {
        onLoad();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createdAt]);

  useEffect(() => {
    if (!deletedID) {
      return;
    }
    setShowConfirmModal(false);
    setshowSuccessModal(true);
  }, [deletedID]);

  useEffect(() => {
    if (!cashTransactionDeleteID) {
      return;
    }
    setShowConfirmModal(false);
    setshowSuccessModal(true);
  }, [cashTransactionDeleteID]);

  useEffect(() => {
    if (isFormSubmit.current) {
      validatePaymentForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPaid, selectedAccount, paymentDate]);

  useEffect(() => {
    if (getPartnerTransaction?.business?.id)
      requestListAccount(accountingDispatch, {
        businessID: getPartnerTransaction.business.id,
      });
  }, [getPartnerTransaction?.business?.id, accountingDispatch]);

  useEffect(() => {
    if (getPartnerTransaction) {
      const { items } = getPartnerTransaction?.accounts || {};
      if (items) {
        items.forEach((account) => {
          if (account.debit > 0) {
            const { account: debitAccount } = account;
            setDebitAccount({
              ...debitAccount,
              label: debitAccount.name,
              value: debitAccount.id,
            });
          }
          if (account.credit > 0) {
            const { account: creditAccount } = account;
            setCreditAccount({
              ...creditAccount,
              label: creditAccount.name,
              value: creditAccount.id,
            });
          }
        });
      }
    }
  }, [getPartnerTransaction]);

  useEffect(() => {
    if (
      getPartnerTransaction.total &&
      getPartnerTransaction.payments &&
      getPartnerTransaction.payments.items
    ) {
      const totalPayments = getPartnerTransaction.payments.items.reduce(
        (total, payment) => total + (payment.total || 0),
        0,
      );

      const difference = getPartnerTransaction.total - totalPayments;

      settotalPaid(
        difference !== 0
          ? { floatValue: difference, value: difference }
          : getPartnerTransaction.total,
      );
    }
  }, [getPartnerTransaction, showPaymentModal]);

  useEffect(() => {
    if (transactionID) {
      setshowSuccessModal(true);
    }
  }, [transactionID]);

  useEffect(() => {
    if (submitError || submitErrorCashbook) {
      setshowErrorModal(true);
      setShowConfirmModal(false);
    }
  }, [submitError, submitErrorCashbook]);

  useEffect(() => {
    if (selectedFilter.value === "MONTHLY") {
      setcreatedAt({
        between: [
          dayjs(date).startOf("month").toISOString(),
          dayjs(date).endOf("month").toISOString(),
        ],
      });
    }
    if (selectedFilter.value === "OTHER") {
      setcreatedAt({
        between: [
          dayjs(startDate?.toISOString()).startOf("day").toISOString(),
          dayjs(endDate?.toISOString()).endOf("day").toISOString(),
        ],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter.value, date, dateRange]);

  const onLoad = () => {
    if (accountingRequest) {
      cancelAPIRequest(accountingRequest);
    }
    if (cashbookRequest) {
      cancelAPIRequest(cashbookRequest);
    }
    if (selectedTransaction.value === "ACCOUNTING") {
      requestListPartnerTransaction(accountingDispatch, {
        partnerID: id,
        page: 1,
        limit: 10,
        createdAt,
      });
    }
    if (selectedTransaction.value === "CASHBOOK") {
      requestListPartnerCashTransaction(businessTransactionDispatch, {
        partnerID: id,
        page: 1,
        limit: 10,
        createdAt,
      });
    }
  };

  const onNext = () => {
    const nextPage = page + 1;
    setpage(nextPage);

    if (selectedTransaction.value === "ACCOUNTING") {
      if (partnerTransactionsNextTokens[nextPage]) {
        requestListPartnerTransaction(accountingDispatch, {
          page: nextPage,
          limit: 10,
          partnerID: id,
          createdAt,
          nextToken: partnerTransactionsNextTokens[nextPage],
        });
      }
    }
    if (selectedTransaction.value === "CASHBOOK") {
      if (partnerCashTransactionsNextTokens[nextPage]) {
        requestListPartnerCashTransaction(businessTransactionDispatch, {
          page: nextPage,
          limit: 10,
          partnerID: id,
          nextToken: partnerCashTransactionsNextTokens[nextPage],
        });
      }
    }
  };

  const onPrev = () => {
    const prevPage = page - 1;
    setpage(prevPage);
    if (selectedTransaction.value === "ACCOUNTING") {
      if (prevPage > 0) {
        requestListPartnerTransaction(accountingDispatch, {
          page: prevPage,
          partnerID: id,
          limit: 10,
          nextToken: partnerTransactionsNextTokens[prevPage],
        });
      }
    }
    if (selectedTransaction.value === "CASHBOOK") {
      if (prevPage > 0) {
        requestListPartnerCashTransaction(businessTransactionDispatch, {
          page: prevPage,
          partnerID: id,
          limit: 10,
          nextToken: partnerCashTransactionsNextTokens[prevPage],
        });
      }
    }
  };

  const onPageChange = (selectedPage) => {
    setpage(selectedPage);
    if (selectedTransaction.value === "ACCOUNTING") {
      if (partnerTransactionsNextTokens[selectedPage] || selectedPage === 1) {
        requestListPartnerTransaction(accountingDispatch, {
          page: selectedPage,
          partnerID: id,
          limit: 10,
          nextToken: partnerTransactionsNextTokens[selectedPage],
        });
      }
    }
    if (selectedTransaction.value === "CASHBOOK") {
      if (
        partnerCashTransactionsNextTokens[selectedPage] ||
        selectedPage === 1
      ) {
        requestListPartnerCashTransaction(businessTransactionDispatch, {
          page: selectedPage,
          partnerID: id,
          limit: 10,
          nextToken: partnerCashTransactionsNextTokens[selectedPage],
        });
      }
    }
  };

  const onDelete = () => {
    if (selectedTransaction.value === "ACCOUNTING") {
      requestDeleteAcctTransaction(accountingDispatch, {
        id: partnerTransactionID,
      });
    }
    if (selectedTransaction.value === "CASHBOOK") {
      requestDeleteCashTransaction(businessTransactionDispatch, {
        id: partnerCashTransactionID,
      });
    }
  };

  const validatePaymentForm = () => {
    let hasErrors = false;
    const validationErrors = {};

    const validateRequiredField = (fieldName, fieldValue, displayFieldName) => {
      if (!fieldValue) {
        validationErrors[fieldName] = `${displayFieldName} is required.`;
        hasErrors = true;
      }
    };

    validateRequiredField("selectedAccount", selectedAccount, "Account");
    validateRequiredField("paymentDate", paymentDate, "Date");
    validateRequiredField("totalPaid", totalPaid?.floatValue, "Total Paid");

    setinputErrors(validationErrors);
    return !hasErrors;
  };

  const handlePayment = () => {
    isFormSubmit.current = true;

    if (!validatePaymentForm()) return;
    if (paymentDateLocked) return;

    const isReceivableType = receivableTransactionTypes.includes(
      getPartnerTransaction?.type,
    );

    const input = {
      created_at: paymentDate.toISOString(),
      total: totalPaid.floatValue,
      accounts: [],
      description: paymentDescription,
      paid: true,
      business_id: getPartnerTransaction?.business?.id,
      partner_id: id,
      parent_transaction_id: getPartnerTransaction?.id,
    };

    const creditAccountValue = creditAccount?.value;
    const debitAccountValue = debitAccount?.value;
    const selectedAccountValue = selectedAccount?.value;

    if (isReceivableType) {
      input.accounts.push({
        id: selectedAccountValue,
        debit: input.total,
        credit: 0,
      });

      input.accounts.push({
        id: debitAccountValue,
        debit: 0,
        credit: input.total,
      });

      input.type = "RECEIVABLE_PAYMENT";
    } else {
      input.accounts.push({
        id: creditAccountValue,
        debit: input.total,
        credit: 0,
      });

      input.accounts.push({
        id: selectedAccountValue,
        debit: 0,
        credit: input.total,
      });

      input.type = "PAYABLE_PAYMENT";
    }

    requestCreateAcctTransaction(accountingDispatch, { input });
  };

  const handleModalSuccess = () => {
    setshowSuccessModal(false);
    setgetPartnerTransaction({});
    setshowPaymentModal(false);
    clearAccountingTransaction(accountingDispatch);
    setselectedAccount(null);
    settotalPaid("");
    setpaymentDescription("");
    setpaymentDate(new Date());
    isFormSubmit.current = false;
  };

  const renderPaymentModal = () => {
    return (
      <Modal
        title={
          ["RECEIVABLE", "INCOME_RECEIVABLE"].includes(
            getPartnerTransaction?.type,
          )
            ? t("Pay Receivable")
            : t("Pay Payable")
        }
        show={showPaymentModal}
        onClose={() => {
          setshowPaymentModal(false);
          setgetPartnerTransaction({});
          setselectedAccount(null);
          setpaymentDescription("");
          setpaymentDate(new Date());
        }}
        footer={
          <div className="p-4 flex justify-end items-center bg-gray-50 rounded-b-lg">
            <Button
              disabled={submitLoading}
              loading={submitLoading}
              onClick={(e) => {
                e.preventDefault();
                handlePayment();
              }}
              className="w-24 shrink-0"
              title="Pay"
            />
          </div>
        }
      >
        <div className="flex flex-col gap-4 px-4 py-5">
          {/* Inline and amber rather than the red ALERT modal — a closed period
              is a status, and the user should stay on their payment form. */}
          <PeriodClosedNotice error={submitError} onRefresh={refetchPeriod} />
          {submitError && !getPeriodClosedError(submitError) && (
            <ModalConfirm
              open={showErrorModal}
              setOpen={(open) => {
                setshowErrorModal(open);
              }}
              title="Error"
              description={
                JSON.parse(submitError?.response?.body)?.message ||
                getErrorMessages(submitError)
              }
              type="ALERT"
              onConfirm={() => {
                clearAcctTransactionError(accountingDispatch);
                clearBusinessTransactionError(businessTransactionDispatch);
              }}
            />
          )}
          {transactionID && (
            <ModalConfirm
              open={showSuccessModal}
              setOpen={(open) => {
                setshowSuccessModal(open);
              }}
              title="Success"
              description={"Your payment transaction was successful."}
              type="SUCCESS"
              onConfirm={() => handleModalSuccess()}
            />
          )}
          <div>
            <label
              htmlFor="paymentDate"
              className="block text-sm font-medium text-gray-700"
            >
              {t("Date")}
            </label>
            <ReactDatePicker
              name="paymentDate"
              className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
              selected={paymentDate}
              onChange={setpaymentDate}
              placeholderText={t("Select Date")}
              dateFormat="dd/MM/yyyy"
              minDate={periodMinDate}
              // A typed closed date is kept so the hint below names the period;
              // the picker alone would drop it silently.
              onChangeRaw={(event) => {
                const typed = parseTypedClosedDate(
                  event?.target?.value,
                  "dd/MM/yyyy",
                  isDateClosed,
                );
                if (typed) setpaymentDate(typed);
              }}
            />
            {periodClosed && (
              <p className="mt-1 text-xs text-amber-700">
                {paymentDateLocked
                  ? t("accounting.period.hints.dateLocked", {
                      date: closedThroughLabel,
                    })
                  : t("accounting.period.banner.closedThrough", {
                      date: closedThroughLabel,
                    })}
              </p>
            )}
            {inputErrors.paymentDate && (
              <div className="mt-1 text-red-600 text-sm">
                {t(inputErrors.paymentDate)}
              </div>
            )}
          </div>
          <div>
            <label
              htmlFor="totalPaid"
              className="block text-sm font-medium text-gray-700"
            >
              {t("Total Paid")}
            </label>
            <NumericFormat
              type="text"
              name="totalPaid"
              id="totalPaid"
              value={totalPaid.value || ""}
              placeholder={t("Enter Total Transaction")}
              thousandSeparator="."
              decimalSeparator=","
              displayType="input"
              prefix={"Rp"}
              onValueChange={(value) => settotalPaid(value)}
              className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            />
            {inputErrors.totalPaid && (
              <div className="mt-1 text-red-600 text-sm">
                {t(inputErrors.totalPaid)}
              </div>
            )}
          </div>
          <div>
            <label
              htmlFor="selectedAccount"
              className="block text-sm font-medium text-gray-700"
            >
              {t("Payment Account")}
            </label>
            <Select
              name="selectedAccount"
              className="mt-1 text-sm"
              classNamePrefix="select2-selection"
              options={accounts
                .filter((account) => account.category === "CASH_AND_BANK")
                .map((account) => ({
                  value: account.id,
                  label: account.name,
                }))}
              value={selectedAccount}
              onChange={setselectedAccount}
              placeholder={t("Choose Account")}
              maxMenuHeight={100}
            />
            {inputErrors.selectedAccount && (
              <div className="mt-1 text-red-600 text-sm">
                {t(inputErrors.selectedAccount)}
              </div>
            )}
          </div>
          <div>
            <label
              htmlFor="paymentDescription"
              className="block text-sm font-medium text-gray-700"
            >
              {t("Description")}
            </label>
            <input
              type="text"
              name="paymentDescription"
              value={paymentDescription || ""}
              placeholder={t("Enter Description")}
              onChange={(e) => setpaymentDescription(e.target.value)}
              className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <div>
      {
        <ModalAlert
          open={showConfirmModal}
          setOpen={(open) => {
            setShowConfirmModal(open);
          }}
          title="Delete Transaction"
          description={
            selectedTransaction.value === "ACCOUNTING"
              ? "Are you sure you want to delete this accounting transaction?"
              : "Are you sure you want to delete this cashbook transaction?"
          }
          confirmButtonText="Yes"
          cancelButtonText="Cancel"
          loadingButton={submitLoading || deleteLoading}
          disabledButton={submitLoading || deleteLoading}
          onConfirm={onDelete}
        />
      }
      {(deletedID || cashTransactionDeleteID) && (
        <ModalConfirm
          open={showSuccessModal}
          type="SUCCESS"
          setOpen={(open) => {
            setshowSuccessModal(open);
          }}
          title="Success"
          description={
            selectedTransaction.value === "ACCOUNTING"
              ? "The accounting transaction has been successfully deleted"
              : "The cash book transaction has been successfully deleted"
          }
        />
      )}
      {renderPaymentModal()}
      {/* Only the accounting table is period-governed; cash-book rows are not
          journals, so the banner follows the accounting view. */}
      {selectedTransaction?.value === "ACCOUNTING" && (
        <PeriodLockBanner businessID={periodBusinessID} className="mb-4" />
      )}
      <div className="space-y-4 mb-4">
        <div className="flex flex-col flex-wrap sm:flex-row gap-4">
          <div>
            <Listbox
              value={selectedTransaction}
              onChange={setselectedTransaction}
            >
              {({ open }) => (
                <>
                  <ListboxButton className="flex items-center justify-between w-full sm:w-48 py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm sm:text-sm">
                    <span className="max-w-full ml-3 mr-2 text-sm text-ellipsis overflow-hidden sm:whitespace-nowrap">
                      {t(selectedTransaction?.label) || t("Transaction Type")}
                    </span>
                    <SelectorIcon className="w-5 h-5 text-gray-500" />
                  </ListboxButton>
                  <Transition
                    show={open}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <ListboxOptions className="absolute z-10 mt-1 bg-white shadow-lg max-h-56 w-11/12 sm:w-48 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                      {partnerTransactionTypesOptions.map((type) => (
                        <ListboxOption
                          key={type.value}
                          className={({ focus }) =>
                            classNames(
                              focus
                                ? "text-white bg-blue-600"
                                : "text-gray-900",
                              "cursor-default select-none relative py-2 pl-3 pr-9",
                            )
                          }
                          value={type}
                        >
                          {({ selected, focus }) => (
                            <>
                              <div className="flex items-center justify-between">
                                <span
                                  className={classNames(
                                    selected ? "font-semibold" : "font-normal",
                                    "ml-3 mr-2 block truncate",
                                  )}
                                >
                                  {t(type.label)}
                                </span>
                                {selected ? (
                                  <span
                                    className={classNames(
                                      focus ? "text-white" : "text-blue-600",
                                      "absolute inset-y-0 right-0 flex items-center pr-4",
                                    )}
                                  >
                                    <CheckIcon className="h-5 w-5" />
                                  </span>
                                ) : null}
                              </div>
                            </>
                          )}
                        </ListboxOption>
                      ))}
                    </ListboxOptions>
                  </Transition>
                </>
              )}
            </Listbox>
          </div>
          <div>
            <Listbox value={selectedFilter} onChange={setSelectedFilter}>
              {({ open }) => (
                <>
                  <ListboxButton className="flex items-center justify-between w-full sm:w-48 py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm text-sm">
                    <span className="max-w-full ml-3 mr-2 text-sm text-ellipsis overflow-hidden sm:whitespace-nowrap">
                      {t(selectedFilter?.label || "Today")}
                    </span>
                    <SelectorIcon className="w-5 h-5 text-gray-500" />
                  </ListboxButton>
                  <Transition
                    show={open}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <ListboxOptions className="absolute z-10 mt-1 bg-white shadow-lg max-h-56 w-11/12 sm:w-48 rounded-md py-1 ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none text-sm">
                      {dateFilterOptions.map((filter) => (
                        <ListboxOption
                          key={filter.value}
                          className={({ focus }) =>
                            classNames(
                              focus
                                ? "text-white bg-blue-600"
                                : "text-gray-900",
                              "cursor-default select-none relative py-2 pl-3 pr-9",
                            )
                          }
                          value={filter}
                        >
                          {({ selected, focus }) => (
                            <>
                              <div className="flex items-center justify-between">
                                <span
                                  className={classNames(
                                    selected ? "font-semibold" : "font-normal",
                                    "ml-3 mr-2 block truncate",
                                  )}
                                >
                                  {t(filter.label)}
                                </span>
                                {selected ? (
                                  <span
                                    className={classNames(
                                      focus ? "text-white" : "text-blue-600",
                                      "absolute inset-y-0 right-0 flex items-center pr-4",
                                    )}
                                  >
                                    <CheckIcon className="h-5 w-5" />
                                  </span>
                                ) : null}
                              </div>
                            </>
                          )}
                        </ListboxOption>
                      ))}
                    </ListboxOptions>
                  </Transition>
                </>
              )}
            </Listbox>
          </div>
          {selectedFilter?.value === "MONTHLY" && (
            <div>
              <ReactDatePicker
                className="block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500 cursor-pointer pl-6 pr-3 disabled:bg-gray-100"
                selected={date}
                showMonthYearPicker
                dateFormat="MM/yyyy"
                onChange={setdate}
              />
            </div>
          )}
          {selectedFilter?.value === "OTHER" && (
            <div>
              <ReactDatePicker
                className="block w-full sm:w-52 text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500 cursor-pointer pl-6 disabled:bg-gray-100"
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                dateFormat="dd/MM/yyyy"
                maxDate={(() => {
                  const maxEndDate = new Date(startDate);
                  maxEndDate.setMonth(maxEndDate.getMonth() + 3);
                  return maxEndDate;
                })()}
                onChange={(update) => {
                  setDateRange(update);
                }}
                placeholderText={t("Select Date Range")}
              />
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col">
        <div className="overflow-x-auto -mx-4 sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden border border-gray-200 rounded-lg shadow-sm">
              {((submitError &&
                partnerTransactionID &&
                !getPeriodClosedError(submitError)) ||
                (submitErrorCashbook && partnerCashTransactionID)) && (
                <div className="bg-white px-4 py-6 sm:px-6">
                  <Alert
                    title="Error"
                    type="error"
                    message={
                      submitError
                        ? (submitError?.response?.body &&
                            JSON.parse(submitError.response.body)?.message) ||
                          submitError?.message
                        : JSON.parse(submitErrorCashbook?.response?.body)
                            ?.message || submitErrorCashbook?.message
                    }
                    errors={submitError?.errors || submitErrorCashbook?.errors}
                  />
                </div>
              )}
              {selectedTransaction?.value === "ACCOUNTING" && (
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Date")}
                      </th>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Description")}
                      </th>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Type")}
                      </th>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Total")}
                      </th>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Action")}
                      </th>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap" />
                    </tr>
                  </thead>
                  {partnerTransactionsLoading ? (
                    <TableSkeleton rows={5} columns={6} />
                  ) : (
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {partnerTransactions?.length > 0 ? (
                        partnerTransactions?.map((item) => {
                          const totalPayments = item.payments.items.reduce(
                            (acc, payment) => acc + payment.total,
                            0,
                          );

                          const isTypeMatch = [
                            "RECEIVABLE",
                            "PAYABLE",
                            "INCOME_RECEIVABLE",
                            "EXPENSE_PAYABLE",
                          ].includes(item.type);
                          return (
                            <tr key={item.id}>
                              <th className="px-4 py-2 font-medium text-sm text-gray-700 whitespace-nowrap ">
                                {dayjs(item.createdAt)
                                  .locale(i18n.language)
                                  .format("DD MMM YYYY")}
                              </th>
                              <td className="px-4 py-2 text-sm text-gray-700 whitespace-nowrap ">
                                {item.description}
                              </td>
                              <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                <div className="flex gap-2">
                                  <div>{t(convertToTitleCase(item.type))}</div>
                                  {totalPayments >= item.total &&
                                  isTypeMatch ? (
                                    <Badge title={t("Paid")} type="success" />
                                  ) : item.paid &&
                                    isTypeMatch &&
                                    totalPayments >= item.total ? (
                                    <Badge title={t("Paid")} type="success" />
                                  ) : null}
                                </div>
                              </td>
                              <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                <NumericFormat
                                  displayType={"text"}
                                  value={item.total}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  prefix={"Rp"}
                                />
                              </td>
                              <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                {isDateClosed(item.createdAt) ? (
                                  <PeriodLockCell
                                    onView={
                                      item.invoiceNumber && item?.items?.items
                                        ? () => navigate(`/invoice/${item.id}`)
                                        : undefined
                                    }
                                  />
                                ) : (
                                <div className="flex flex-auto gap-2">
                                  {item.invoiceNumber && item?.items?.items ? (
                                    <button
                                      onClick={() => {
                                        navigate(`/invoice/${item.id}`);
                                      }}
                                    >
                                      <EyeIcon className="h-5 w-5 text-blue-500" />
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        navigate(
                                          `/accounting-transaction/create?id=${item.id}`,
                                        )
                                      }
                                    >
                                      <PencilAltIcon className="h-5 w-5 text-blue-500" />
                                    </button>
                                  )}
                                  <button
                                    onClick={() => {
                                      setShowConfirmModal(true);
                                      setpartnerTransactionID(item.id);
                                    }}
                                  >
                                    <TrashIcon className="h-5 w-5 text-red-500" />
                                  </button>
                                </div>
                                )}
                              </td>
                              <td>
                                {totalPayments < item.total && isTypeMatch ? (
                                  <button
                                    onClick={() => {
                                      setshowPaymentModal(true);
                                      setgetPartnerTransaction(item);
                                    }}
                                    className="px-4 py-2 font-medium text-sm text-left text-blue-500 whitespace-nowrap"
                                  >
                                    {t("Pay")}
                                  </button>
                                ) : !item.paid &&
                                  isTypeMatch &&
                                  totalPayments < item.total ? (
                                  <button
                                    onClick={() => {
                                      setshowPaymentModal(true);
                                      setgetPartnerTransaction(item);
                                    }}
                                    className="px-4 py-2 font-medium text-sm text-left text-blue-500 whitespace-nowrap"
                                  >
                                    {t("Pay")}
                                  </button>
                                ) : null}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <ErrorStateTable
                          colSpan={6}
                          error={partnerTransactionsError}
                        />
                      )}
                    </tbody>
                  )}
                </table>
              )}
              {selectedTransaction?.value === "CASHBOOK" && (
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("ID")}
                      </th>
                      <td className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Date")}
                      </td>
                      <td className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Information")}
                      </td>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Sale")}
                      </th>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Expense")}
                      </th>
                      <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                        {t("Action")}
                      </th>
                    </tr>
                  </thead>
                  {partnerCashTransactionsLoading ? (
                    <TableSkeleton rows={3} columns={6} />
                  ) : (
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {partnerCashTransactions?.length > 0 ? (
                        partnerCashTransactions.map((transaction) => {
                          const shortId = transaction.id.substr(
                            transaction.id.length - 5,
                          );
                          return (
                            <tr key={transaction.id}>
                              <td className="px-4 py-2 font-medium text-sm text-gray-00 whitespace-nowrap ">
                                <a href={`/cash-book/${transaction.id}`}>
                                  {shortId}
                                </a>
                              </td>
                              <td className="px-4 py-2 font-medium text-sm text-gray-00 whitespace-nowrap ">
                                {dayjs(transaction.createdAt)
                                  .locale(i18n.language)
                                  .format("DD MMM YYYY")}
                              </td>
                              <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                {transaction.note}
                              </td>
                              <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                <NumericFormat
                                  displayType={"text"}
                                  value={transaction.income}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  prefix={"Rp"}
                                />
                              </td>
                              <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                <NumericFormat
                                  displayType={"text"}
                                  value={transaction.expense}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  prefix={"Rp"}
                                />
                              </td>
                              <td className="px-4 py-2 text-sm text-left text-gray-700 whitespace-nowrap">
                                <div className="flex flex-auto gap-2">
                                  <button
                                    onClick={() => {
                                      setShowConfirmModal(true);
                                      setpartnerCashTransactionID(
                                        transaction.id,
                                      );
                                    }}
                                  >
                                    <TrashIcon className="h-5 w-5 text-red-500" />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <ErrorStateTable error={partnerCashTransactionsError} />
                      )}
                    </tbody>
                  )}
                </table>
              )}
              <Pagination
                page={page}
                onPrev={onPrev}
                onNext={onNext}
                onPageChange={onPageChange}
                nextTokens={
                  selectedTransaction === "ACCOUNTING"
                    ? partnerTransactionsNextTokens
                    : partnerCashTransactionsNextTokens
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PartnerTransactionList;
